import type { MarketVariants } from '@/lib/i18n'

export type Slide1TitleCopy = {
  eyebrow: string
  title: string
  subtitle: string
  hintDesktop: string
  hintMobile: string
}

export const copy: MarketVariants<Slide1TitleCopy> = {
  US: {
    eyebrow: 'Chapter 6',
    title: 'If the worst happens.',
    subtitle: 'How to respond, recover, and get back in control.',
    hintDesktop: 'Tip: Arrow keys also work',
    hintMobile: 'Swipe or tap Next',
  },
  ar: {
    eyebrow: 'الفصل 6',
    title: 'إذا وقع الأسوأ.',
    subtitle: 'كيف تتصرّف، وتتعافى، وتستعيد زمام الأمور.',
    hintDesktop: 'نصيحة: يمكنك أيضاً استخدام مفاتيح الأسهم',
    hintMobile: 'اسحب أو اضغط "التالي"',
  },
}
